/** Deterministic face genes shared by the client preview and the server, so a previewed face is the founded face. */
import { FACE_GENE_COUNT } from './types';

export const MAX_FACE_SEED = 2_147_483_646;

function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const r3 = (v: number) => Math.round(v * 1000) / 1000;
const clamp01 = (v: number) => Math.max(0, Math.min(1, v));

/** A founder's face: FACE_GENE_COUNT independent genes 0..1. */
export function faceFromSeed(seed: number): number[] {
  const rnd = mulberry32(seed);
  const f: number[] = [];
  for (let i = 0; i < FACE_GENE_COUNT; i++) f.push(r3(rnd()));
  return f;
}

/** A child's face: the parents' average plus seeded noise (sd ~0.12), so children resemble their parents. */
export function childFaceFromSeed(seed: number, a: readonly number[], b: readonly number[]): number[] {
  const rnd = mulberry32(seed);
  const f: number[] = [];
  for (let i = 0; i < FACE_GENE_COUNT; i++) {
    const noise = (rnd() + rnd() + rnd() + rnd() - 2) * 0.208; // sd 0.577 * 0.208 ~ 0.12
    f.push(r3(clamp01(((a[i] ?? 0.5) + (b[i] ?? 0.5)) / 2 + noise)));
  }
  return f;
}
